export const PARTNER_IDENTIFIER = {
  RLAXX: "rlx",
  VIDEOCIETY: "vc",
  PURTEL: "ptl",
};
